module.exports = __webpack_public_path__ + "img/partner.3946684e.jpg";